import { AvatarListModule } from '@delon/abc/avatar-list';
import { DatePickerModule } from '@delon/abc/date-picker';
import { DownFileModule } from '@delon/abc/down-file';
import { EllipsisModule } from '@delon/abc/ellipsis';
import { ErrorCollectModule } from '@delon/abc/error-collect';
import { ExceptionModule } from '@delon/abc/exception';
import { FooterToolbarModule } from '@delon/abc/footer-toolbar';
import { FullContentModule } from '@delon/abc/full-content';
import { GlobalFooterModule } from '@delon/abc/global-footer';
import { NoticeIconModule } from '@delon/abc/notice-icon';
import { PageHeaderModule } from '@delon/abc/page-header';
import { QuickMenuModule } from '@delon/abc/quick-menu';
import { ResultModule } from '@delon/abc/result';
import { SidebarNavModule } from '@delon/abc/sidebar-nav';
import { TagSelectModule } from '@delon/abc/tag-select';

export const SHARED_DELON_MODULES = [
  AvatarListModule,
  DatePickerModule,
  DownFileModule,
  EllipsisModule,
  ErrorCollectModule,
  ExceptionModule,
  FooterToolbarModule,
  GlobalFooterModule,
  GlobalFooterModule,
  PageHeaderModule,
  ResultModule,
  TagSelectModule,
  NoticeIconModule,
  QuickMenuModule,
  SidebarNavModule,
  FullContentModule,
];
